import { render, staticRenderFns } from "./Info_Slide.vue?vue&type=template&id=dbec1f26&scoped=true&"
import script from "./Info_Slide.vue?vue&type=script&lang=js&"
export * from "./Info_Slide.vue?vue&type=script&lang=js&"
import style0 from "./Info_Slide.vue?vue&type=style&index=0&id=dbec1f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbec1f26",
  null
  
)

export default component.exports